<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() }}</h3>
    </div>
  </div>
  <form class="form form-group-seperator-dashed" [formGroup]="meetingForm">
    <div class="navi-hover card-body">
      <div class="card-body-progress">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>
      <kt-alert *ngIf="hasFormErrors" type="warn" [showCloseButton]="false" [duration]="10000">
        {{ 'AUTH.VALIDATION.INVALID_OR_REQUIRED' | translate }}
      </kt-alert>
      <kt-alert
        *ngIf="hasSubmissionErrors && !hasFormErrors"
        type="warn"
        [duration]="30000"
        [showCloseButton]="false"
      >
        <ul>
          <li *ngFor="let msg of submissionErrorObj">{{ msg.error | translate }}</li>
        </ul>
      </kt-alert>
      <div>
        <div class="row">
          <div
            class="col-lg-8"
            style="max-height: 500px; overflow-y: scroll"
            [perfectScrollbar]="{ wheelPropagation: false }"
          >
            <div class="row">
              <div class="col kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'MEETING.INPUT.SUBJECT' | translate }}</mat-label>
                  <input required matInput formControlName="subject" />
                  <mat-error *ngIf="isControlHasError('subject', 'required')">
                    Subject field is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col kt-margin-bottom-20-mobile">
                <kt-general-autocomplete
                  [label]="'Organizer'"
                  [loadItemsFunction]="organizerAutocompleteCall"
                  [optionFormatter]="stringUtils.displayUserName"
                  [valueFormatter]="stringUtils.displayUserName"
                  [required]="true"
                  [control]="meetingForm.get('call_organizer')"
                  [change]="onOrganizerChange.bind(this)"
                  [dataPath]="'data'"
                  [placeholder]="'Select Organizer'"
                  #organizerAutocomplete
                ></kt-general-autocomplete>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col kt-margin-bottom-20-mobile">
                <button
                  *ngIf="participantTypeCtrl.value === 'CONTACT'"
                  class="pl-2"
                  mat-button
                  (click)="openContactDialog()"
                >
                  <i class="ml-2 ki ki-plus text-secondary"></i>
                  New Contact
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col kt-margin-bottom-20-mobile">
                <kt-general-autocomplete
                  [appearance]="'fill'"
                  [label]="'Contact'"
                  [loadItemsFunction]="searchParticipantsFn"
                  [optionFormatter]="stringUtils.autocompleteEntityFormatter"
                  [valueFormatter]="stringUtils.autocompleteEntityFormatter"
                  [required]="true"
                  [readOnly]="false"
                  [control]="participantCtrl"
                  [change]="selected.bind(this, 1)"
                  [dataPath]="'data'"
                  [placeholder]="'Select Contact'"
                  [chipList]="true"
                  [objects]="participantCtrl.value"
                  [formatNewObjectFn]="formatNewEntityFn"
                  #entityAutocomplete
                ></kt-general-autocomplete>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col kt-margin-bottom-20-mobile">
                <mat-button-toggle-group
                  #affiliateType="matButtonToggleGroup"
                  aria-label="Type"
                  [formControl]="affiliateTypeCtrl"
                  class="special-button-group"
                >
                  <mat-button-toggle (change)="searchAffiliates()" value="DOCTOR"
                    >{{ 'MENU.DOCTOR' | translate }}
                  </mat-button-toggle>
                  <mat-button-toggle (change)="searchAffiliates()" value="FACILITY"
                    >{{ 'MENU.FACILITY' | translate }}
                  </mat-button-toggle>
                  <mat-button-toggle (change)="searchAffiliates()" value="PATIENT"
                    >{{ 'MENU.PATIENT' | translate }}
                  </mat-button-toggle>
                </mat-button-toggle-group>
              </div>
            </div>
            <div class="row">
              <div class="col kt-margin-bottom-20-mobile">
                <kt-general-autocomplete
                  [appearance]="'fill'"
                  [label]="'MEETING.INPUT.RELATED_TO' | translate"
                  [loadItemsFunction]="searchAffiliatesFn"
                  [optionFormatter]="stringUtils.autocompleteEntityFormatter"
                  [valueFormatter]="stringUtils.autocompleteEntityFormatter"
                  [required]="false"
                  [readOnly]="false"
                  [control]="affiliateCtrl"
                  [change]="selected.bind(this, 3)"
                  [dataPath]="'data'"
                  [placeholder]="'Select Entities'"
                  [chipList]="true"
                  [objects]="affiliateCtrl.value"
                  [formatNewObjectFn]="formatAffiliatesEntityFn"
                  #affiliatesAutocomplete
                ></kt-general-autocomplete>
              </div>
            </div>
            <div class="row">
              <div class="col kt-margin-bottom-20-mobile">
                <kt-general-autocomplete
                  [appearance]="'fill'"
                  [label]="'MEETING.INPUT.RESPONSIBLE' | translate"
                  [loadItemsFunction]="searchAssigneeFn"
                  [optionFormatter]="filterAssigneeFn"
                  [valueFormatter]="filterAssigneeFn"
                  [required]="false"
                  [readOnly]="false"
                  [control]="assigneeCtrl"
                  [change]="selected.bind(this, 2)"
                  [dataPath]="'data'"
                  [placeholder]="'Select Entities'"
                  [chipList]="true"
                  [objects]="assigneeCtrl.value"
                  [formatNewObjectFn]="formatAssigneeEntityFn"
                  #responsibleAutocomplete
                ></kt-general-autocomplete>
              </div>
            </div>
            <div class="row">
              <div class="col kt-margin-bottom-20-mobile">
                <kt-general-autocomplete
                  [label]="'Drug'"
                  [loadItemsFunction]="drugAutocompleteCall"
                  [optionFormatter]="filterDrugFn"
                  [valueFormatter]="filterDrugFn"
                  [required]="false"
                  [control]="meetingForm.get('drug')"
                  [change]="onDrugChange.bind(this)"
                  [dataPath]="'data'"
                  [placeholder]="'Select Drug'"
                  #drugAutocomplete
                ></kt-general-autocomplete>
              </div>
            </div>
            <div class="row">
              <div class="col kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'MEETING.INPUT.DESCRIPTION' | translate }}</mat-label>
                  <textarea matInput formControlName="body" rows="7"></textarea>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-lg-4 second-section">
            <div class="row">
              <mat-form-field class="col kt-margin-bottom-20-mobile" appearance="standard">
                <mat-label>Start Time</mat-label>
                <input
                  required
                  [owlDateTime]="dt1"
                  matInput
                  placeholder="start time"
                  class="clendar-btn"
                  formControlName="from_time"
                />
                <owl-date-time [hour12Timer]="'true'" #dt1></owl-date-time>
                <mat-icon class="clickable" [owlDateTimeTrigger]="dt1" matSuffix
                  >access_time</mat-icon
                >
              </mat-form-field>
            </div>
            <div class="row">
              <div class="col-8 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="standard">
                  <mat-label>Duration</mat-label>
                  <input matInput type="number" formControlName="duration" />
                </mat-form-field>
              </div>
              <div class="col-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="standard">
                  <mat-label>Duration Type</mat-label>
                  <mat-select formControlName="duration_type">
                    <mat-option value="M">Minutes</mat-option>
                    <mat-option value="H">Hours</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="standard">
                  <mat-label>{{ 'MEETING.INPUT.LOCATION' | translate }}</mat-label>
                  <mat-select formControlName="location">
                    <mat-option value="Client Side (In person)">Client Side (In person)</mat-option>
                    <mat-option value="Virtual">Virtual</mat-option>
                    <mat-option value="Telephone">Telephone</mat-option>
                    <mat-option value="Other (No longer Free Form)"
                      >Other (No longer Free Form)</mat-option
                    >
                  </mat-select>
                  <mat-error *ngIf="isControlHasError('location', 'required')">
                    {{ 'AUTH.VALIDATION.REQUIRED_FIELD' | translate }}
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <div class="col kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="standard">
                  <mat-label>{{ 'MEETING.INPUT.TYPE' | translate }}</mat-label>
                  <mat-select formControlName="sales_call_type">
                    <mat-option value="New Lead">New Lead</mat-option>
                    <mat-option value="Lead Follow-up">Lead Follow-up</mat-option>
                    <mat-option value="New Opportunity (Existing Client)"
                      >New Opportunity (Existing Client)</mat-option
                    >
                    <mat-option value="Existing Client Follow-up"
                      >Existing Client Follow-up</mat-option
                    >
                    <mat-option value="Review Meeting">Review Meeting</mat-option>
                    <mat-option value="Event Resolution">Event Resolution</mat-option>
                    <mat-option value="Information Gathering">Information Gathering</mat-option>
                    <mat-option value="Other">Other</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <ng-template ngxPermissionsOnly="accessToTagCommunication">
              <div class="row">
                <div class="col col-sm-12">
                  <kt-tags
                    [autocompleteEntity]="'COMMUNICATION'"
                    [controlObject]="tags"
                    [appearance]="'standard'"
                    [canAddComponent]="true"
                    [value]="tags$"
                    category="Communication"
                  ></kt-tags>
                </div>
              </div>
            </ng-template>
            <div class="row mb-3" style="padding-left: 15px">
              <div class="col">
                <mat-slide-toggle
                  class="row mt-2 mr-2"
                  formControlName="is_completed"
                  [(ngModel)]="is_completedChecked"
                ></mat-slide-toggle>
                <mat-hint align="start">
                  <strong>{{ is_completedChecked | meetingStatus : 'TEXT' }}</strong>
                </mat-hint>
              </div>
              <div class="col">
                <mat-slide-toggle
                  class="row mt-2 mr-2"
                  formControlName="is_important"
                  [(ngModel)]="is_importantChecked"
                ></mat-slide-toggle>
                <mat-hint align="start">
                  <strong>{{ is_importantChecked ? 'Important' : 'Not important' }}</strong>
                </mat-hint>
              </div>
              <div class="col kt-margin-bottom-20-mobile"></div>
            </div>

            <div class="row">
              <div class="col kt-margin-bottom-20-mobile">
                <!--                <input formControlName="files" type="file" name="attachments" (change)="onFileChange($event)" multiple/>-->
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  style="
                    border-radius: 0;
                    width: 100%;
                    text-align: center;
                    bottom: 0;
                    background-color: white;
                  "
                  (click)="data.mode === 'create' ? fileInput.click() : fileInput2.click()"
                >
                  <i class="flaticon-add-circular-button fa-s"></i> Add Attachment
                  <input
                    style="display: none"
                    #fileInput
                    type="file"
                    name="attachments"
                    (change)="onFileChange($event)"
                    multiple
                  />
                  <input
                    style="display: none"
                    #fileInput2
                    type="file"
                    name="updatedAttachments"
                    (change)="onFileUpdated($event)"
                    multiple
                  />
                </button>
                <div class="mt-2 mb-4" style="padding-bottom: 30px">
                  <h6 class="text-muted">{{ 'TASK.ATTACHMENTS' | translate }}</h6>
                  <div
                    *ngFor="let a of attachments"
                    style="max-height: 100px; max-width: 100px; display: inline-block"
                  >
                    <div
                      class="card card-custom overlay"
                      [matTooltip]="returnAttachmentNameTooltip(a)"
                    >
                      <div class="card-body p-0">
                        <div class="overlay-wrapper">
                          <img [src]="getSvgPath(a)" alt="" class="w-100 rounded" />
                        </div>
                        <div class="overlay-layer">
                          <button
                            type="button"
                            class="btn btn-sm btn-icon btn-light btn-hover-success"
                            *ngIf="data.mode === 'update'"
                            (click)="openLink($event, a.url)"
                          >
                            <i class="flaticon-eye icon-md"></i></button
                          >&nbsp;
                          <button
                            type="button"
                            class="btn btn-sm btn-icon btn-light btn-hover-danger"
                            *ngIf="data.mode === 'update' && attachments.length > 0"
                            (click)="deleteAttachment(a, 'latest')"
                          >
                            <i class="flaticon-delete icon-md"></i>
                          </button>
                          <button
                            type="button"
                            class="btn btn-sm btn-icon btn-light btn-hover-danger"
                            *ngIf="data.mode === 'create' && attachments.length > 0"
                            (click)="deleteAttachment(a, 'latest')"
                          >
                            <i class="flaticon-delete icon-md"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    *ngFor="let a of updatedAttachments"
                    style="max-height: 100px; max-width: 100px; display: inline-block"
                  >
                    <div class="card card-custom overlay" [matTooltip]="a">
                      <div class="card-body p-0">
                        <div class="overlay-wrapper">
                          <img [src]="getSvgPath(a, 'update')" alt="" class="w-100 rounded" />
                        </div>
                        <div class="overlay-layer">
                          <button
                            type="button"
                            class="btn btn-sm btn-icon btn-light btn-hover-danger"
                            (click)="deleteAttachment(a, 'updated')"
                          >
                            <i class="flaticon-delete icon-md"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <kt-custom-progress-bar
              *ngIf="showFileLoader | async"
              [requests]="uploadRequests"
              [totalFileSize]="totalFileSize"
              (callback)="callbackOnFileLoad()"
            ></kt-custom-progress-bar>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button (click)="close()" type="button" mat-raised-button matTooltip="Cancel">
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            color="primary"
            [disabled]="clicked"
            (click)="onSubmit()"
            matTooltip="Create"
          >
            <span translate="AUTH.INPUT.SAVE">Save</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
